"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("../create-validator");
var messages_1 = require("../messages");
var valid_nino_1 = require("valid-nino");
exports.validNINumber = create_validator_1.createValidatorFactory(function (s) { return !s || valid_nino_1.default(s); }, messages_1.INVALID_NI_NUMBER);
